module.exports = __webpack_public_path__ + "img/safety-tool-fta-item2-1.2fd3c704.png";